/**
 * @file ErrorPage404.jsx
 *
 * @version 1.0.0
 * @author Carmelino Galang
 * @copyright Copyright (c) 2024, NetCyberOps LLC
 */
import React from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";

import "./ErrorPage.css";

import NavLogo from "@assets/logos/nav-logo4.svg";

export default function Error() {
  return (
    <div className="error-page-wrapper pt-5">
      <Image src={NavLogo} className="landing-logo mb-5" fluid />
      <h1>Oops!</h1>
      <h3>404 - Page not found</h3>
      <h5>The requested page could not be found</h5>
      <Link to="/" className="mt-3">
        <h4>Return to Homepage</h4>
      </Link>
    </div>
  );
}
